import { useCallback } from "react";
import { useUserContext } from "../stores/userContext";
import { useLiveSessionStore } from "../stores/useLiveSessionStore";
import { useHttpClient } from "./useHttpClient";
import { useNavigate } from "react-router-dom";
import { useLocalization } from "../stores/localizationContext";


export function useCloseSession() {
  const { user } = useUserContext();
  const sessionData = useLiveSessionStore((state) => state.sessionData);
  const api = useHttpClient();
  const navigate = useNavigate();
  const { lang } = useLocalization();
  
  const handleCloseSession = useCallback(async () => {
    if (!sessionData?.sessionId || !user?.userId) {
      console.warn("Missing sessionId or userId — cannot close session.");
      return;
    }

    try {
      const endpoint = import.meta.env.VITE_END_SESSION_ENDPOINT
        .replace("{session_id}", sessionData.sessionId)
        .replace("{educator_id}", user.userId);

      const response = await api.post(endpoint);

      if (response.status === 200) {
         localStorage.removeItem('sessionDurationInMinutes');
        navigate(`/${lang}`);
      } else {
        console.error("Failed to close session:", response.data);
      }
    } catch (error) {
      console.error("Error closing session:", error);
    }
  }, [api, navigate, lang, sessionData?.sessionId, user?.userId]);

  return { handleCloseSession };
}
